module.exports = __webpack_public_path__ + "img/expedia.42235351.png";